import { render, staticRenderFns } from "./transaction-detail.vue?vue&type=template&id=3a0aee58&scoped=true&"
import script from "./transaction-detail.vue?vue&type=script&lang=js&"
export * from "./transaction-detail.vue?vue&type=script&lang=js&"
import style0 from "./transaction-detail.vue?vue&type=style&index=0&id=3a0aee58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0aee58",
  null
  
)

export default component.exports